import { useState, useEffect } from 'react'
import { gql } from '@apollo/client'
import { useMutation } from '@apollo/client/react'
import { Button, Table, Alert } from 'reactstrap'
import Spinner from '../Spinner/Spinner'
import { SCHEMAS_QUERY, SET_USER_ATTRIBUTE_MUTATION, TOGGLE_SCHEMA_INACTIVE_MUTATION } from '../../graphql.js'
import { handleGraphQLErrors, configValue, getAttributeValue, setAttributeValue } from '../../utils.js'
import { ATTRIBUTE_NAME } from '../../constants.js'

const SCHEMAS = gql(SCHEMAS_QUERY)
const SET_USER_ATTRIBUTE = gql(SET_USER_ATTRIBUTE_MUTATION)
const TOGGLE_SCHEMA_INACTIVE = gql(TOGGLE_SCHEMA_INACTIVE_MUTATION)

export default function Schemas() {
  console.log('Schemas rendered')

  const initHideInactiveSchemas = getAttributeValue('Hide Inactive Schemas') === 'N' ? 'N' : 'Y'

  const [items, setItems] = useState([])
  const [hideInactiveSchemas, setHideInactiveSchemas] = useState(initHideInactiveSchemas)
  const [schemaToggled, setSchemaToggled] = useState()
  const [spinner, setSpinner] = useState(false)
  const [graphQLErrors, setGraphQLErrors] = useState([])
  const [setUserAttribute] = useMutation(SET_USER_ATTRIBUTE)

  useEffect(() => {
    async function fetchItems() {
      try {
        setSpinner(true)
        const { data, errors } = await window.apolloClient.query({ query: SCHEMAS })
        if (data.schemas) {
          console.log(data.schemas)
          setItems(data.schemas)
        } 
        if (errors) {
          setGraphQLErrors(errors)
        }
      } catch (err) {
        handleGraphQLErrors(err, setGraphQLErrors)
      }
      setSpinner(false)
    }
    fetchItems()
  }, [hideInactiveSchemas, schemaToggled])

  async function toggleHideInactive() {
    const newValue = hideInactiveSchemas === 'Y' ? 'N' : 'Y'
    await setUserAttribute({ variables: { attributeName: ATTRIBUTE_NAME.hideInactiveSchemas, attributeValue: newValue } })
    setAttributeValue(ATTRIBUTE_NAME.hideInactiveSchemas, newValue)
    setHideInactiveSchemas(newValue)
  }

  async function toggleSchemaInactive(schema) {
    await window.apolloClient.query({ query: TOGGLE_SCHEMA_INACTIVE, variables: { schema: schema } })
    setSchemaToggled(new Date())
  }

  if (graphQLErrors.length > 0) {
    return <Alert color="danger">{graphQLErrors[0].message}</Alert>
  }
  if (spinner) {
    return <Spinner />
  }

  const schemaTable = []
  let lineNumber = 1
  const host = configValue('Host')
  for (let schema of items) {
    const ce1Href = `${host}/ce1/${schema.name.toLowerCase()}/home`
    const ce2Href = `${host}/${schema.name.toLowerCase()}/home`
    const ce1Link = <a href={ce1Href} target="_blank" rel="noreferrer">{schema.name.toUpperCase()}</a>
    const ce2Link = <a href={ce2Href} target="_blank" rel="noreferrer">{schema.name.toUpperCase()}</a>
    let backgroundColor = 'white'
    if (schema.inactive === 'Y') {
      backgroundColor = '#ADD8E6'
    }
    schemaTable.push(
      <tr key={schema.name}>
        <td style={{ backgroundColor: backgroundColor, textAlign: 'center' }}>{lineNumber}</td>
        <td style={{ backgroundColor: backgroundColor }}>{ce1Link}</td>
        <td style={{ backgroundColor: backgroundColor }}>{ce2Link}</td>
        <td style={{ backgroundColor: backgroundColor }}>{schema.created}</td>
        <td style={{ backgroundColor: backgroundColor, textAlign: 'center' }}><Button color="primary" onClick={() => toggleSchemaInactive(schema.name)}>Toggle Active</Button></td>
        <td style={{ backgroundColor: backgroundColor }}>{schema.description}</td>
      </tr>
    )
    lineNumber++
  }
  const buttonText = hideInactiveSchemas === 'Y' ? 'Show' : 'Hide' 
  return (
    <div style={{ height: '100%', overflow: 'auto'}}>
      <div style={{ textAlign: 'center', padding: '10px' }}>
        <Button color="secondary" onClick={toggleHideInactive}>{buttonText} Inactive Schemas</Button>
      </div>
      <Table bordered style={{ width: 'auto', margin: 'auto'}}>
        <thead>
          <tr>
            <td>#</td>
            <td style={{ textAlign: 'left' }}>CE1</td>
            <td style={{ textAlign: 'left' }}>CE2</td>
            <td>Created</td>
            <td>Toggle Active</td>
            <td>Description</td>
          </tr>
        </thead>
        <tbody>
          {schemaTable}
        </tbody>
      </Table>
    </div>
  )
}
